import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User, UserState } from "../types/user";

const initialState: UserState = {
  value: {},
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.value = action.payload;
    },
    resetUser: (state) => {
      state.value = {};
    },
  },
});

export const { setUser, resetUser } = userSlice.actions;
export default userSlice.reducer;
